/** @sfdc-extension-file SNK */
import type { PreloadFallbackProps } from '@/lib/page-designer/preload-fallback-registry';
import HeroCarouselSkeleton from './skeleton';

// oxlint-disable-next-line react/only-export-components -- synchronous fallback discovery reads this metadata export
export const componentTypeIds = ['Layout.heroCarousel'] as const;

export default function HeroCarouselPreloadFallback({ component }: PreloadFallbackProps) {
    const data = component.data as { slides?: unknown[]; showDots?: boolean; showNavigation?: boolean } | undefined;

    return (
        <div data-slot="component-preload-fallback" data-component-type={component.typeId} aria-hidden="true">
            <HeroCarouselSkeleton
                slideCount={data?.slides?.length}
                showDots={data?.showDots}
                showNavigation={data?.showNavigation}
            />
        </div>
    );
}
